import { useCallback, useEffect, useState } from "react";

const THEME_EVENT = "sr-theme-change";

// Shared light/dark theme state — backed by the `.dark` class + `sr-theme`
// localStorage key already used across the app (index.css defines both
// palettes). Extracted from Navbar so any page/header can toggle theme.
// Multiple components mount this hook at once (Navbar, app header, sign-in
// corner toggle, profile menu) — a custom event keeps every instance's
// `dark` boolean in sync when any one of them calls `toggle()`.
export function useTheme() {
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("sr-theme");
    const sys = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const isDark = saved ? saved === "dark" : sys;
    setDark(isDark);
    document.documentElement.classList.toggle("dark", isDark);

    const onChange = (e) => setDark(e.detail.dark);
    window.addEventListener(THEME_EVENT, onChange);
    return () => window.removeEventListener(THEME_EVENT, onChange);
  }, []);

  const toggle = useCallback(() => {
    const root = document.documentElement;
    const next = !root.classList.contains("dark");
    root.classList.add("theme-fade");
    root.classList.toggle("dark", next);
    localStorage.setItem("sr-theme", next ? "dark" : "light");
    window.setTimeout(() => root.classList.remove("theme-fade"), 550);
    window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: { dark: next } }));
  }, []);

  return { dark, toggle };
}
